import React from "react";
import { ScanLine, Camera as CameraIcon, Upload as UploadIcon, Pencil } from "lucide-react";

// -----------------------------------------------------------------------------
// ScanModePicker — first screen of the ScanDialog. 4 choices: MRZ auto,
// visual OCR, NFC file import, or blank manual entry.
// Extracted from ReceptionTab.jsx (Iteration 62 — modularisation).
// -----------------------------------------------------------------------------
export default function ScanModePicker({ IT, onPick }) {
  const options = [
    { key: "mrz",    icon: ScanLine,   badge: IT ? "Consigliato" : "Recommended",
      title: IT ? "Lettura Codici / MRZ" : "Codes / MRZ reader",
      body: IT ? "Passaporto, CIE 2.0, permesso elettronico. Auto-scan continuo sulla zona MRZ."
               : "Passport, CIE 2.0, electronic residence permit. Continuous auto-scan on the MRZ band.",
      color: "sage" },
    { key: "ocr",    icon: CameraIcon, title: IT ? "OCR Testuale" : "Text OCR",
      body: IT ? "Patente, tessera sanitaria, documenti senza MRZ. OCR visivo generalista."
               : "Driving licence, health card, docs without MRZ. General visual OCR.",
      color: "primary" },
    { key: "nfc",    icon: UploadIcon, title: IT ? "Importa da NFC" : "Import from NFC",
      body: IT ? "Trascina il file JSON/TXT esportato dal lettore NFC. Estrazione istantanea 100% affidabile."
               : "Drop the JSON/TXT file from your external NFC reader. Instant 100% accurate.",
      color: "sage" },
    { key: "manual", icon: Pencil,     title: IT ? "Inserimento Manuale" : "Manual entry",
      body: IT ? "Documento illeggibile o non a mano? Compila i campi con dropdown assistiti."
               : "Illegible document? Fill the fields with assisted dropdowns.",
      color: "amber" },
  ];
  const tone = { sage: "border-sage/40 bg-sage/5 hover:bg-sage/15", primary: "border-primary/40 bg-primary/5 hover:bg-primary/15", amber: "border-amber-500/40 bg-amber-500/5 hover:bg-amber-500/15" };
  const iconTone = { sage: "text-sage bg-sage/15", primary: "text-primary bg-primary/15", amber: "text-amber-700 bg-amber-500/15" };
  return (
    <div className="grid gap-3" data-testid="scan-mode-picker">
      <div className="text-xs uppercase tracking-widest text-muted-foreground text-center">
        {IT ? "Scegli come vuoi acquisire il documento" : "Choose how to capture the document"}
      </div>
      {options.map((o) => {
        const Icon = o.icon;
        return (
          <button key={o.key} type="button" onClick={() => onPick(o.key)}
            className={`border-2 rounded-lg p-4 text-left transition-all flex gap-4 items-start lift ${tone[o.color]}`}
            data-testid={`scan-mode-pick-${o.key}`}>
            <div className={`shrink-0 w-11 h-11 rounded-full grid place-items-center ${iconTone[o.color]}`}>
              <Icon className="w-5 h-5"/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap mb-1">
                <span className="font-display text-lg">{o.title}</span>
                {o.badge && <span className="text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded bg-sage text-white">{o.badge}</span>}
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">{o.body}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
